import type { Draft } from '../../../entities/Draft'
import { Wrapper } from '../styles'
import { FirstComment } from './FirstComment'
import { PostTypeFacebookStory } from '~publish/legacy/post/constants'
import { useSplitEnabled } from '@buffer-mono/features'
import AppStore from '~publish/legacy/composer/composer/stores/AppStore'

export const FacebookChannelFields = ({
  draft,
}: {
  draft: Draft
}): JSX.Element => {
  const { isEnabled: isFacebookFirstCommentEnabled } =
    useSplitEnabled('facebook-comment')
  const selectedFacebookProfiles = AppStore.getSelectedProfilesForService(
    draft.id,
  )
  const facebookGroupIsSelected = selectedFacebookProfiles.some(
    (profile) => profile.serviceType === 'group',
  )

  if (
    !draft.service.isFacebook() ||
    draft.updateType === PostTypeFacebookStory ||
    !isFacebookFirstCommentEnabled ||
    facebookGroupIsSelected
  ) {
    return <></>
  }

  return (
    <Wrapper>
      <FirstComment draft={draft} />
    </Wrapper>
  )
}
